import React from "react";
import { GiftIcon, CheckIcon } from "lucide-react";
import { CTAButton } from "./CTAButton";
import { bonuses } from "../data/landing";
export function Bonuses() {
  return <section className="bg-navy-950 py-16 text-white sm:py-20" data-id="element-68" data-mp="av35ut3p3515">
      <div className="mx-auto max-w-5xl" data-id="element-69" data-mp="autf33atstue">
        <div className="mx-auto max-w-2xl px-5 text-center" data-id="element-70" data-mp="ftwmguea3c5j">
          <span className="inline-flex items-center gap-2 rounded-full bg-gold-400 px-4 py-1.5 text-sm font-extrabold text-navy-950" data-id="element-71" data-mp="fs3cp68dcbtb">
            <GiftIcon className="h-4 w-4" aria-hidden="true" data-id="element-72" data-mp="5vqmwjfy2i3u" /> Included free with your purchase
          </span>
          <h2 className="mt-4 font-display text-3xl font-black leading-tight sm:text-4xl" data-id="element-73" data-mp="3o250ghaawq1p">
            Five Additional Resources to Make Your Denture Blueprint <span className="text-gold-400" data-id="element-74" data-mp="3t0y99wen7svj">Even More Practical</span>
          </h2>
          <p className="mt-4 text-base leading-relaxed text-navy-200" data-id="element-75" data-mp="1mars1i94k00w">
            I've included five complementary resources to help you organize specific parts of your workflow — at no additional charge.
          </p>
        </div>

        <ol className="mt-12 space-y-16" data-id="element-76" data-mp="3ic3kica096gx">
          {bonuses.map((b, i) => <li key={b.number} className="md:grid md:grid-cols-2 md:items-center md:gap-10 md:px-5" data-id="element-77" data-mp="3dd90j70axbv8" data-mpi={i}>
              <div className={i % 2 === 1 ? "md:order-2" : ""} data-id="element-78" data-mp="3r8ukgzroh5gs">
                <img src={b.image} alt={`Bonus #${b.number}: ${b.title}`} className="block w-full" loading="lazy" data-id="element-79" data-mp="3n67smyv0bkjl" />
              </div>
              <div className="mt-6 px-5 md:mt-0 md:px-0" data-id="element-80" data-mp="2zhoi0cohivoc">
                <div className="flex flex-wrap items-center gap-3" data-id="element-81" data-mp="2uhivtc0zi1dn">
                  <span className="rounded-lg bg-gold-400 px-3 py-1 text-sm font-black text-navy-950" data-id="element-82" data-mp="38g0id6f5l7tz">Bonus #{b.number}</span>
                  <span className="text-sm text-navy-300" data-id="element-83" data-mp="33g4aux78yy9o">
                    Value <s data-id="element-84" data-mp="nq1dx6xbhgw4">${b.value}</s> → <strong className="text-emerald-400" data-id="element-85" data-mp="npi124mixioy">FREE today</strong>
                  </span>
                </div>
                <h3 className="mt-3 font-display text-2xl font-black leading-tight sm:text-3xl" data-id="element-86" data-mp="iq560wli15ba">{b.title}</h3>
                <p className="mt-3 text-base leading-relaxed text-navy-200" data-id="element-87" data-mp="3ciell2ggpsyk">{b.description}</p>
                <p className="mt-5 text-sm font-bold text-gold-300" data-id="element-88" data-mp="3hgolfqd4thqi">You'll receive:</p>
                <ul className="mt-2 space-y-2" data-id="element-89" data-mp="3lknwvujk1qd0">
                  {b.items.map(item => <li key={item} className="flex gap-2.5 text-[15px] leading-snug text-navy-200" data-id="element-90" data-mp="3qhmoa5bu3j7i">
                      <CheckIcon className="mt-0.5 h-5 w-5 shrink-0 text-gold-400" aria-hidden="true" data-id="element-91" data-mp="2ttgel40220md" />
                      {item}
                    </li>)}
                </ul>
                <p className="mt-4 text-sm italic leading-relaxed text-navy-300" data-id="element-92" data-mp="32s24xlbrqjxp">{b.note}</p>
              </div>
            </li>)}
        </ol>

        <div className="mt-14 px-5" data-id="element-93" data-mp="37lo9eq7s3hif">
          <CTAButton label="Yes! I Want the 5 Free Bonuses" sub="Bonuses only included with today's $27 offer" data-id="element-94" data-mp="2a57kupiv5mkr" />
        </div>
      </div>
    </section>;
}